export const ROUTES = {
    auth: '/auth',
    login: '/auth/login',
    adminDashboard: '/admin/dashboard',
    statistics: '/estatisticas',
    panel: '/painel',
    transportManagementPath: '/painel/gerencia-transportes',
    transportManagement: '/gerencia-transportes',
    management: '/administracao',
    alerts: '/alertas',
    trafficViolationsPath: '/painel/gerencia-transportes/infracoes',
    trafficViolations: '/infracoes',
    addTrafficViolation: '/infracoes/novo',
    addTrafficViolationVideoMonitoring: '/infracoes/novo/videomonitoramento',
    deferTrafficViolation: '/infracoes/deferir/:id',
    digitalCollections: '/recolhimentos-digitais',
    violationConfirmPaymentsPath: '/confirmar-pagamentos-cnab150',
    darvCreate: '/darv-avulso',
    drvList: '/drv-lista',
    trafficViolationsConfirmPayment: '/confirmar-pagamento/:id',
    trafficViolationsDeferPath: '/painel/gerencia-transportes/infracoes/deferir/:id',
    trafficViolationInformDriver: '/indicar-condutor/:id',
    trafficViolationInformDriverPath: '/painel/gerencia-transportes/infracoes/indicar-condutor/:id',
    violationCardPayments: '/pagamentos-infracoes-radar',
    violationCardPaymentsPath: '/painel/gerencia-transportes/pagamentos-infracoes-radar',
    violationCardPaymentsNew: '/novo',
    violationCardPaymentsEditPath: '/painel/gerencia-transportes/pagamentos-infracoes-radar/editar/:id',
    violationCardPaymentsEdit: '/editar/:id',
    trafficViolationsCancelPath: '/painel/gerencia-transportes/infracoes/cancelar/:id',
    trafficViolationsDetailsPath: '/painel/gerencia-transportes/infracoes/detalhes/:id',
    trafficViolationsDetailsTimelinePrintPath: '/painel/gerencia-transportes/infracoes/imprimir-linha-tempo/:id',
    trafficViolationsDocuments: '/documentos-infracoes',
    trafficViolationDocumentsAdd: '/novo',
    trafficViolationDocumentsEdit: '/editar',
    trafficViolationsDocumentsPath: '/painel/gerencia-transportes/documentos-infracoes',
    trafficViolationsDocumentsAddPath: '/painel/gerencia-transportes/documentos-infracoes/novo',
    trafficViolationsDocumentsEditPath: '/painel/gerencia-transportes/documentos-infracoes/editar',
    cancelTrafficViolation: '/infracoes/cancelar/:id',
    searches: '/consultas',
    searchVehicle: '/veiculos',
    searchPlate: '/placa',
    searchChassis: '/chassi',
    searchDrivers: '/condutores',
    searchDriversHistory: '/historico',
    searchDriversBlockers: '/bloqueios',
    searchCpf: '/cpf',
    searchCpfCnpj: '/cpf-cnpj',
    searchNoRecord: '/nada-consta',
    searchSne: '/sne',
    searchCnh: "/cnh",
    searchName: "/nome",
    getNoRecordPath: '/painel/gerencia-transportes/consultas/veiculos/nada-consta?placa=:plate',
    getSnePath: '/painel/gerencia-transportes/consultas/veiculos/sne?placa=:plate',
    searchViolationHistory: '/historico-infracao',
    searchAit: '/ait',
    searchSenatran: '/denatran',
    searchSenatranDrivers: '/consulta-condutores',
    searchSenatranBasicVehicles: '/consulta-basica-veiculos',
    searchSenatranDetailedVehicles: '/consulta-detalhada-veiculos',
    searchSenatranViolations: '/consulta-infracoes',
    searchSenatranOwnerAddress: '/consulta-endereco',
    searchSenatranViolationPayments: '/consulta-pagamentos-infracoes',
    searchSenatranViolationEvents: '/consulta-ocorrencias-infracoes',
    violationAllotmentsPath: '/painel/gerencia-transportes/lotes',
    violationAllotments: '/lotes',
    violationAllotmentsValidationPath: '/painel/gerencia-transportes/lotes/validacao',
    violationAllotmentsValidation: '/lotes/validacao',
    violationAllotmentsValidate: '/lotes/validar/:allotmentId',
    violationAllotmentsValidateViolation: '/lotes/validar/:allotmentId/:violationId',
    violationAllotmentsViolations: '/lotes/infracoes/:allotmentId',
    violationAllotmentsPrintingNAsPath: '/painel/gerencia-transportes/lotes/imprimir-nas',
    violationAllotmentsPrintingNAs: '/imprimir-nas',
    violationAllotmentsPrintingNPsPath: '/painel/gerencia-transportes/lotes/imprimir-nps',
    violationAllotmentsPrintingNPs: '/imprimir-nps',
    processes: '/processos',
    processesPath: '/painel/gerencia-transportes/processos',
    detailsDefault: '/detalhes/:id',
    editDefault: '/editar/:id',
    processesAdd: '/novo',
    processesEditPath: '/painel/gerencia-transportes/processos/editar/:id',
    processesDetailsPath: '/painel/gerencia-transportes/processos/detalhes/:id',
    processesForward: '/encaminhar/:id',
    judgeProcesses: '/julgar/:id',
    processesForwardPath: '/painel/gerencia-transportes/processos/encaminhar/:id',
    judgeProcessesPath: '/painel/gerencia-transportes/processos/julgar/:id',
    processesArchive: '/arquivar/:id',
    processesArchivePath: '/painel/gerencia-transportes/processos/arquivar/:id',
    processesConfirmReceipt: '/confirmar-recebimento/:id',
    processesConfirmReceiptPath: '/painel/gerencia-transportes/processos/confirmar-recebimento/:id',
    processesSendEmail: '/enviar-email/:id',
    processesSendEmailPath: '/painel/gerencia-transportes/processos/enviar-email/:id',
    processesReexamination: '/reexaminar/:id',
    processesReexaminationPath: '/painel/gerencia-transportes/processos/reexaminar/:id',
    processesFinalDecision: '/preencher-decisao-final/:id',
    processesFinalDecisionPath: '/painel/gerencia-transportes/processos/preencher-decisao-final/:id',
    processLetterPdf: '/painel/gerencia-transportes/processos/imprimir-carta-pdf/:id',
    processPrintFinalDecision: '/painel/gerencia-transportes/processos/imprimir-parecer/:id',
    processPrintNpsTrial: '/imprimir-nps-relato-julgamento',
    processPrintCaPath: '/painel/gerencia-transportes/processos/imprimir-capa/:id',
    transports: '/transportes',
    parkingCredentials: '/credenciais-estacionamento',
    parkingCredentialsAdd: '/novo',
    parkingCredentialsAddPath: '/painel/gerencia-transportes/credenciais-estacionamento/novo',
    parkingCredentialsEditPath: '/painel/gerencia-transportes/credenciais-estacionamento/editar/:id',
    parkingCredentialsDocuments: '/documentos-credenciais-estacionamento',
    parkingCredentialsDocumentsPath: '/painel/gerencia-transportes/documentos-credenciais-estacionamento',
    parkingCredentialsDocumentsAddPath: '/painel/gerencia-transportes/documentos-credenciais-estacionamento/novo',
    parkingCredentialsDocumentAdd: '/novo',
    parkingCredentialsDocumentsEditPath: '/painel/gerencia-transportes/documentos-credenciais-estacionamento/editar',
    parkingCredentialsDocumentEdit: '/editar/:id',
    reports: '/relatorios',
    reportsPath: '/painel/gerencia-transportes/relatorios',
    reportsManagerial: '/gerencial',
    reportsManagerialPath: "/painel/gerencia-transportes/relatorios/gerencial",
    reportsViolationsQualitative: "/qualitativo-infracoes",
    reportsViolationsQualitativePath: "/painel/gerencia-transportes/relatorios/qualitativo-infracoes",
    reportsAgentTracking: "/rastreamento-agentes",
    reportsAgentTrackingPath: "/painel/gerencia-transportes/relatorios/rastreamento-agentes",
    monthlyReport: "/:type",
    monthlyReportPath: "/painel/gerencia-transportes/relatorios/:type",
    help: '/ajuda',
    settings: '/configuracoes',
    parameters: '/parametros',
    parametersPath: '/painel/administracao/parametros',
    parametersEdit: '/editar/:id',
    parametersEditPath: '/painel/administracao/parametros/editar/:id',
    camerasPath: '/painel/gerencia-transportes/cameras',
    cameras: '/cameras',
    camerasAddPath: '/painel/gerencia-transportes/cameras/novo',
    camerasAdd: '/novo',
    camerasEditPath: '/painel/gerencia-transportes/cameras/editar/:id',
    camerasEdit: '/editar/:id',
    breathalyzersPath: '/painel/gerencia-transportes/etilometros',
    breathalyzers: '/etilometros',
    breathalyzersAddPath: '/painel/gerencia-transportes/etilometros/novo',
    breathalyzersAdd: '/novo',
    breathalyzersEditPath: '/painel/gerencia-transportes/etilometros/editar/:id',
    breathalyzersEdit: '/editar/:id',
    equipmentsPath: '/painel/gerencia-transportes/equipamentos',
    equipments: '/equipamentos',
    equipmentsAddPath: '/painel/gerencia-transportes/equipamentos/novo',
    equipmentsAdd: '/equipamentos/novo',
    equipmentsEditPath: '/painel/gerencia-transportes/equipamentos/editar/:id',
    equipmentsEdit: '/equipamentos/editar/:id',
    aitBlocksPath: '/painel/gerencia-transportes/blocos-ait',
    aitBlocks: '/blocos-ait',
    aitBlocksAddPath: '/painel/gerencia-transportes/blocos-ait/novo',
    aitBlocksAdd: '/novo',
    aitBlocksEditPath: '/painel/gerencia-transportes/blocos-ait/editar/:id',
    aitBlocksEdit: '/editar/:id',
    boatsPath: '/painel/gerencia-transportes/boats',
    boats: '/boats',
    boatsAddPath: '/painel/gerencia-transportes/boats/novo',
    boatsAdd: '/novo',
    boatsEditPath: '/painel/gerencia-transportes/boats/editar/:id',
    boatsEdit: '/editar/:id',
    boatsDetailsPath: '/painel/gerencia-transportes/boats/:id',
    boatsDetails: '/:id',
    boatsDrawingPath: '/painel/gerencia-transportes/boats/desenho/:id',
    boatsDrawing: '/desenho/:id',
    publicBoatsPath: '/painel/boats/publicos',
    publicBoats: '/boats/publicos',
    publicBoatDetailsPath: '/painel/boats/publicos/:id',
    publicBoatDetails: '/boats/publicos/:id',
    users: '/usuarios',
    usersPath: '/painel/administracao/usuarios',
    usersAdd: '/novo',
    usersAddPath: '/painel/administracao/usuarios/novo',
    usersEdit: '/editar/:id',
    usersEditPath: '/painel/administracao/usuarios/editar/:id',
    usersDetails: '/detalhes/:id',
    usersDetailsPath: '/painel/administracao/usuarios/detalhes/:id',
    usersAccessTime: '/horarios-acesso-usuario',
    usersAccessTimePath: '/painel/administracao/horarios-acesso-usuario',
    usersAccessTimeAdd: '/novo',
    usersAccessTimeAddPath: '/painel/administracao/horarios-acesso-usuario/novo',
    usersAccessTimeEdit: '/editar/:id',
    usersAccessTimeEditPath: '/painel/administracao/horarios-acesso-usuario/editar',
    documents: '/documentos',
    documentsPath: '/painel/administracao/documentos',
    documentsAdd: '/novo',
    documentsAddPath: '/painel/administracao/documentos/novo',
    documentsEdit: '/editar/:id',
    documentsEditPath: '/painel/administracao/documentos/editar',
    agents: '/agentes',
    agentsPath: '/painel/gerencia-transportes/agentes',
    agentsAdd: '/novo',
    agentsAddPath: '/painel/gerencia-transportes/agentes/novo',
    agentsEdit: '/editar/:id',
    agentsEditPath: '/painel/gerencia-transportes/agentes/editar/:id',
    agentsDetails: '/detalhes/:id',
    agentsDetailsPath: '/painel/gerencia-transportes/agentes/detalhes/:id',
    agentsSchedulesPath: '/painel/gerencia-transportes/escalas-agentes',
    agentsSchedules: '/escalas-agentes',
    agentsSchedulesAddPath: '/painel/gerencia-transportes/escalas-agentes/novo',
    agentsSchedulesAdd: '/novo',
    agentsSchedulesEditPath: '/painel/gerencia-transportes/escalas-agentes/editar/:id',
    agentsSchedulesEdit: '/editar/:id',
    person: '/pessoas',
    personPath: '/painel/administracao/pessoas',
    personAdd: '/novo',
    personAddPath: '/painel/administracao/pessoas/novo',
    personEdit: '/editar/:id',
    personEditPath: '/painel/administracao/pessoas/editar/:id',
    audits: '/auditorias',
    auditsPath: '/painel/administracao/auditorias',
    permittee: '/permissionarios',
    permitteePrintDocumentBatch: '/imprimir-documentos-lote',
    permitteePrintLicenseBatch: '/imprimir-alvaras-lote',
    permitteesAdd: '/novo',
    permitteesAddPath: '/painel/gerencia-transportes/permissionarios/novo',
    permitteesEdit: '/editar/:id',
    permitteesEditPath: '/painel/gerencia-transportes/permissionarios/editar/:id',
    permitteeDocuments: '/documentos-permissionarios',
    permitteeDocumentsPath: '/painel/gerencia-transportes/documentos-permissionarios',
    permitteesDocumentsAddPath: '/painel/gerencia-transportes/documentos-permissionarios/novo',
    permitteeDocumentAdd: '/novo',
    permitteesDocumentsEditPath: '/painel/gerencia-transportes/documentos-permissionarios/editar',
    permitteeDocumentEdit: '/editar/:id',
    permitteedDocumentsSendDetranPath: '/painel/gerencia-transportes/documentos-permissionarios/enviar-detran',
    permitteeDocumentSendDetran: '/enviar-detran/:id/',
    permitteeDetailsPath: '/painel/gerencia-transportes/permissionarios/detalhes/:id',
    permitteePrintDocumentBatchPdf: '/painel/gerencia-transportes/documentos-permissionarios/imprimir-pdf/:codes/:id',
    permitteePrintDocument: '/painel/gerencia-transportes/documentos-permissionarios/imprimir/:code/:id',
    permitteeValidateLicensePath: '/painel/gerencia-transportes/documentos-permissionarios/validar/:code',
    transportViolations: '/infracoes-transporte',
    passwordChangePath: '/painel/geral/alterar-senha',
    passwordChange: '/geral/alterar-senha'
}
